// extracted by mini-css-extract-plugin
export var bodySections = "_63-8";
export var gray = "_63-7";
export var green = "_63-4";
export var iconContainer = "_63-9";
export var iconWidgetContainer = "_63-1";
export var phoneIcon = "_63-2";
export var red = "_63-5";
export var statusDot = "_63-3";
export var widgetContainer = "_63-0";
export var yellow = "_63-6";